import { FileReader, FileWriter } from '@/platform'

class ActionDetail {
    public actionIndex: number = 0 // 动作索引
    public actionName: string = '' // 动作名称
    public actionType: number = 0 // 动作类型

    readBin(reader: FileReader): void {
        this.actionIndex = reader.readInt()
        this.actionName = reader.readString()
        this.actionType = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.actionIndex)
        writer.writeString(this.actionName)
        writer.writeInt(this.actionType)
    }

    readVersionedOui(reader: FileReader): void {
        this.actionIndex = reader.readInt()
        this.actionName = reader.readString()
        this.actionType = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.actionIndex)
        writer.writeString(this.actionName)
        writer.writeInt(this.actionType)
        writer.writerLength()
    }
}

export default ActionDetail
